import { render } from "./People.vue?vue&type=template&id=dbbef9ec&scoped=true"
import script from "./People.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./People.vue?vue&type=script&charset=utf-8&lang=js"

import "./People.vue?vue&type=style&index=0&id=dbbef9ec&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbbef9ec"]])

export default __exports__